import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Header";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";

import { useSidebar } from "../../App";

export default function Helpmodelattack() {
  const { sidebarCollapsed } = useSidebar();
  const { t } = useTranslation("help");

  const tableRows = t("helpmodelattack.table.rows", {
    returnObjects: true,
    defaultValue: [
      {
        area: "Model provider and version alignment",
        purpose: "Ensures tests target the exact model in use.",
        detail:
          "Confirm the profile points to the same provider/version configured in the Model Endpoint."
      },
      {
        area: "Safety and policy test files",
        purpose: "Provide prompts that exercise model behavior.",
        detail:
          "Use built-in datasets for baseline coverage or uploaded datasets for organization-specific policies."
      },
      {
        area: "Expected result patterns",
        purpose: "Define how WhiteHaX identifies failures.",
        detail:
          "For each test case, expected patterns should identify unsafe, non-compliant, or policy-violating output in a measurable way."
      },
      {
        area: "Repeatability",
        purpose: "Supports model regression testing.",
        detail:
          "Keep a stable profile for each release gate so reports can be compared over time."
      }
    ]
  });

  return (
    <div className="theme-whbl">
      {/* Internal CSS */}
      <style>{`
        .dark-guide-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          font-family: "Segoe UI", Arial, sans-serif;
          font-size: 14px;
          color: #e5e7eb;
          background: #111827;
          border: 1px solid #374151;
        }

        .dark-guide-table thead th {
          background: #1f2937;
          color: #60a5fa;
          font-weight: 700;
          text-align: left;
          padding: 12px 14px;
          border: 1px solid #4b5563;
          vertical-align: middle;
        }

        .dark-guide-table tbody td {
          background: #111827;
          color: #e5e7eb;
          padding: 12px 14px;
          border: 1px solid #374151;
          vertical-align: top;
          line-height: 1.55;
        }

        .dark-guide-table tbody tr:nth-child(even) td {
          background: #172033;
        }

        .dark-guide-table tbody tr:hover td {
          background: #1e293b;
        }

        .dark-guide-table th:nth-child(1),
        .dark-guide-table td:nth-child(1) {
          width: 23%;
        }

        .dark-guide-table th:nth-child(2),
        .dark-guide-table td:nth-child(2) {
          width: 30%;
        }

        .dark-guide-table th:nth-child(3),
        .dark-guide-table td:nth-child(3) {
          width: 47%;
        }

        @media (max-width: 768px) {
          .dark-guide-table {
            min-width: 750px;
          }
        }

        .help-row {
          display: block;
          gap: 16px;
          padding: 16px 18px;
          border-bottom: 1px solid #e5e7eb;
          align-items: flex-start;
        }

        .help-row:last-child {
          border-bottom: none;
        }

        .help-row p {
          width: 100%;
          max-width: 100%;
          margin: 0;
          font-size: 14px;
          line-height: 1.6;
          color: #fff;
        }

        .help-row img {
          width: 100%;
          max-width: 650px;
          border-radius: 6px;
          padding: 10px;
          transition: transform 0.8s ease;
          margin: 10px 0;
        }

        @media (max-width: 768px) {
          .help-row {
            flex-direction: column;
          }

          .help-row p,
          .help-row img {
            width: 100%;
            max-width: 100%;
          }
        }
      `}</style>

      <div className="container-fluid">
        <div className="main-container">
          {/* Main Content */}
          <main
            style={{
              width: "97%",
              overflowX: "auto"
            }}
          >
            <div className="dashboard">
              {/* Title */}
              <div className="pm-header">
                <h1 className="pm-title">
                  {t(
                    "helpmodelattack.title",
                    "AI Model Attack Surface Profile"
                  )}
                </h1>
              </div>

              {/* Content */}
              <div
                style={{
                  backgroundColor: "#10172a",
                  borderRadius: "6px",
                  marginTop: "15px",
                  overflow: "hidden"
                }}
              >
                {/* Step 1 */}
                <div className="help-row">
                  <p>
                    {t(
                      "helpmodelattack.description",
                      "Use this profile type when the target is a model or model gateway and the goal is to evaluate model-facing risks rather than application workflow or MCP protocol risks."
                    )}
                  </p>
                </div>

                {/* Step 2 */}
                <div className="help-row">
                  <img   src={t("helpmodelattack.image")}     alt="DoS"  style={{ padding: "10px 0" }}   /> <br/><br/>
                  <img   src={t("helpmodelattack.image2")}       /> <br/><br/>
<img   src={t("helpmodelattack.image3")}     alt="DoS"  style={{ padding: "10px 0" }}   /> <br/><br/>
                  <table className="dark-guide-table">
                    <thead>
                      <tr>
                        <th>
                          {t(
                            "helpmodelattack.table.headers.area",
                            "Area"
                          )}
                        </th>
                        <th>
                          {t(
                            "helpmodelattack.table.headers.purpose",
                            "Purpose"
                          )}
                        </th>
                        <th>
                          {t(
                            "helpmodelattack.table.headers.detail",
                            "User-guide detail"
                          )}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {(Array.isArray(tableRows) ? tableRows : []).map(
                        (row, index) => (
                          <tr key={index}>
                            <td>{row.area}</td>
                            <td>{row.purpose}</td>
                            <td>{row.detail}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}